require('../../vendor/svg4everybody');


//////////////////
// WEBPACK FOOTER
// ./js/components/plugins/svg.js
// module id = 12
// module chunks = 0